import React from "react";
import { Field, FieldRenderProps } from "react-final-form"
import SelectionButton from "../controls/SelectionButton";
import TextField from "./TextField";
import { LoanType } from "../../types/loan";
import { getLoanPurposes } from "../../utils/loan";
import { t } from "../../i18n"

interface LoanPurposeFieldProps {
  i18nKey?: string;
  loanType: LoanType;
  name: string;
  refinancingOnly?: boolean;
}

const renderField = (renderProps: FieldRenderProps<number | string>): React.ReactNode => {
  const { input, i18nKey, refinancingOnly, loanType } = renderProps;
  const loanPurposes = getLoanPurposes(loanType);

  return (
    <div>
      <div className="text-md-bold">{t(i18nKey)}</div>
      <div>
        {loanPurposes.map(purpose => (
          <SelectionButton
            disabled={refinancingOnly && purpose !== "refinancing"}
            i18nKey={`loan.purposes.${purpose}`}
            input={input}
            key={purpose}
            symbolId={`${purpose}-loan`}
            value={purpose}
          />
        ))}
      </div>
      {input.value === "other" && (
        <div>
          <p className="mt-10 mb-5">{t("loan.specify_loan_purpose")}</p>
          <TextField
            i18key="loan.type"
            name="otherPurpose"
          />
        </div>
      )}
    </div>
  )
}

const LoanPurposeField: React.FC<LoanPurposeFieldProps> = (props: LoanPurposeFieldProps) => {
  return (
    <Field {...props} render={renderField}/>
  )
}

export default LoanPurposeField
